import React, { ChangeEvent, ReactElement, ReactNode } from 'react';

import './file-picker.scss';

type Props = {
  triggerElement: ReactNode;
  fileType?: string;
  fileRef: React.MutableRefObject<HTMLInputElement | null>;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

const FilePicker = ({ triggerElement, fileType = '*', fileRef, onChange }: Props): ReactElement => {
  return (
    <div className="file-picker">
      {triggerElement}
      <input accept={fileType} type="file" ref={fileRef} value="" onChange={onChange} data-testid="file-picker" />
    </div>
  );
};

export default FilePicker;
